import { PYTHON_URL} from "./urls"
// let mi_token = typeof sessionStorage !== 'undefined'?sessionStorage.getItem('token-access'):'';
var cod_municipio = typeof sessionStorage !== 'undefined'?sessionStorage.getItem('codigo-municipio'):'';

export function verifySession(email){
  return fetch(PYTHON_URL+'api/autenticacion/token_formulario/'+email, {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        // Authorization: 'Bearer ' + mi_token
      }  
  })
}
export function verifyToken(token,data){
  return fetch(PYTHON_URL+'api/autenticacion/token/verify/', {
      method: "POST",
      data: data,
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        Authorization: 'Bearer ' + token
      }  
  })
}

export function consulta(ruta,id){
  
    return fetch(PYTHON_URL+'api/formulario/'+ruta+id+'/'+cod_municipio, {
        method: "GET",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + getToken()
        }  
    })
}

export function guardar(formdata,id_form,token,cod_mun){ 
  let token_guardar=token?token:getToken()
  let municipio = cod_municipio!=''?cod_municipio: cod_mun
  return fetch(PYTHON_URL+'api/formulario/guardar/'+id_form+'/'+municipio, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token_guardar
    },  
    body: formdata
  })
}

export function guardarKeys(formdata){ 
  return fetch(PYTHON_URL+'api/formulario/agregar_keys/'+cod_municipio, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken()
    },  
    body: formdata
  })
}

export function borrar(id_form,id_data){
  return fetch(PYTHON_URL+'api/formulario/borrar/'+id_form+'/'+id_data+'/'+cod_municipio, {
    method: 'DELETE',
    headers: {
      Authorization: 'Bearer ' + getToken()
    },  
  })
}

export function actualizar(id_form,id_data,formdata,token,cod_mun){
  let token_guardar=token?token:getToken()
  let municipio = cod_municipio!=''?cod_municipio: cod_mun
  return fetch(PYTHON_URL+'api/formulario/actualizar/'+id_form+'/'+id_data+'/'+municipio, {
    method: 'PATCH',
    headers: {
      Authorization: 'Bearer ' + token_guardar
    }, 
    body: formdata 
  })
}

export function guardarImagen(id_form,formdata,ruta,id_div,token,cod_mun){
  let token_guardar=token?token:getToken()
  let municipio = cod_municipio!=''?cod_municipio: cod_mun
  return fetch(PYTHON_URL+'api/formulario/imagenes/guardar/'+id_form+'/'+ruta+'/'+id_div+'/'+municipio, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token_guardar
    },  
    body: formdata
  })
}

export function borrarImagen(id_form,id_data,id_file,div_img,id_historico){
  return fetch(PYTHON_URL+'api/formulario/imagenes/borrar/'+id_form+'/'+id_data+'/'+div_img+'/'+id_file+'/'+id_historico+'/'+cod_municipio, {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + getToken()
    },  
  })
}

export function cargarImagen(id_form,id_data,div_img){
  return fetch(PYTHON_URL+'api/formulario/imagenes/cargar/'+id_form+'/'+id_data+'/'+div_img+'/'+cod_municipio, {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + getToken()
    },  
  })
}

export function cargarImagenes(id_form,id_data){

  return fetch(PYTHON_URL+'api/formulario/imagenes/total/'+id_form+'/'+id_data+'/'+cod_municipio, {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + getToken()
    },  
  })
}

export function consultaListasApi(ruta_api,campo_nombre,id_data){
  return fetch(PYTHON_URL+'api/'+ruta_api+campo_nombre+'/'+id_data+'/'+cod_municipio, {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + getToken()
    },  
  })
}

///obtener token
function getToken() {
    return typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('token-access') : '';
}